import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { signUserOut } from "../init-firebase";
import { LOGIN_URL } from "../urls";

export default function LogoutPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      await signUserOut();
      navigate(LOGIN_URL);
    };

    handleLogout();
  }, [navigate]);

  return (
    <div className="flex min-h-full flex-col bg-white pb-12 pt-16">
      <main className="mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="mt-2 text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
            Logging out...
          </h1>
        </div>
      </main>
    </div>
  );
}
